// https://github.com/remybach/jQuery.clientSideLogging/blob/master/jQuery.clientSideLogging.js

// var Const = require('../defines');
//
// var $ = require('./jCube');
// var Lang = require('./uk');
// var App = require('./App');

function CubeError(property, data) {

	Error.call(this, property);

	this.name = "CubeError";
	this.property = property;
	this.data = data || {};
	this.message = property.toString();



	if (Error.captureStackTrace) {
		Error.captureStackTrace(this, CubeError);
	} else {
		this.stack = (new Error()).stack;
	}
}

function ApiError(property, response) {

	Error.call(this, property) ;

	this.name = "ApiError";
	this.property = property;
	this.data = response || {};
	this.message = property.toString();



	if (Error.captureStackTrace) {
		Error.captureStackTrace(this, ApiError);
	} else {
		this.stack = (new Error()).stack;
	}
}


CubeError.prototype = Object.create(Error.prototype);
ApiError.prototype = Object.create(Error.prototype);

/**
 * Private method. Use App.logError(e, data)
 *
 * @param e
 * @param file
 * @param line
 * @param column
 */
function logError (e, file, line, column) {

	var _data = {};
	var stack = e.stack ? e.stack.split('\n').filter(function (el) {
		return el.length > 0;
	}) : [];

	if(typeof file == 'object') {
	    _data = file;
	    file = '';
    }

    var _file = file ? file : '';
    var _col = column ? ':' + column : '';
    var _line = line ? ' [' + line + _col + ']' : '';


	_errorSend({
		'message': e.message,
        'file': _file + _line,
		'name': e.name ? e.name : 'Unknown error',
		'data': JSON.stringify(_data),
		'stack': JSON.stringify(stack),
		'window_info': JSON.stringify({
			'userAgent': navigator.userAgent,
			'screenSize': window.screen.availWidth + ' x ' + window.screen.availHeight,
			'location': window.location.href,
			'cookieEnabled': navigator.cookieEnabled,
			'language': navigator.language,
			'platform': navigator.platform,
			'appCodeName': navigator.appCodeName,
			'appName': navigator.appName
		})
	})
}

/**
 * Private method
 *
 * @param data
 * @return {null}
 * @private
 */
function _errorSend (data) {

	if( !icube_args['settings']['api_url'] ){
		console.error("Invalid ErrorApi Url");
		return null;
	}

	var url = icube_args['settings']['api_url'] + '/jsexception';
	var xhr = null;

	if (window.XMLHttpRequest || window.ActiveXObject) {
		if (window.ActiveXObject) {
			try {
				xhr = new ActiveXObject("Msxml2.XMLHTTP");
			} catch(e) {
				xhr = new ActiveXObject("Microsoft.XMLHTTP");
			}
		} else {
			xhr = new XMLHttpRequest();
		}

	} else {
		console.error("Browser not support XMLHTTPRequest...");
		return null;
	}

	xhr.onreadystatechange = function() {

		if (xhr.readyState === 4) {

			if (xhr.status !== 200 && xhr.status !== 0) {
				console.log.error("Error sending error to iCube server");
			}
		}
	};

	function urlEncode (_data) {
		var res = '';
		for (var x in _data) {
			res += res !== "" ? "&" : "";
			res += encodeURIComponent(x) + "=" + encodeURIComponent(data[x]);
		}

		return res;
	}

	xhr.open('POST', url, true);
	xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
	xhr.send(urlEncode(data));

}

module.exports.CubeError = CubeError;
module.exports.ApiError = ApiError;
module.exports.logError = logError;